import { Component, h, Prop, Host, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'uui-switch',
  styleUrl: 'uui-switch.css',
  shadow: true
})
export class UUISwitch {
  @Prop({ reflect: true, mutable: true }) selected: boolean = false;
  @Prop({ reflect: true }) disabled: boolean = false;
  @Prop({ reflect: true }) value: string | number;
  @Prop({ reflect: true }) name: string;
  /** determines the spacing between the input and label */
  @Prop() justify?: 'flex-start' | 'space-between' = 'flex-start';
  /** optional label that will render alongside the input */
  @Prop({ reflect: true }) label?: string;
  /** DEPRECATED - please use toggleChange  */
  @Event({ bubbles: true, composed: true }) toggle?: EventEmitter;
  /** triggered when switch is toggled. Passes back current selected state */
  @Event({ bubbles: true, composed: true }) toggleChange?: EventEmitter;
  @Prop() inputProps: { [key: string]: string | number };

  onToggle(e) {
    console.warn(
      'toggle will be deprecated in a future release. Please use toggleChange.'
    );
    if (this.disabled) {
      return;
    }

    this.selected = !this.selected;
    this.toggle.emit(e);
  }

  onToggleChange(e) {
    if (this.disabled) {
      return;
    }

    this.selected = !this.selected;
    this.toggleChange.emit(e);
  }

  render() {
    return (
      <Host style={{ justifyContent: this.justify }}>
        {this.label ? <label htmlFor={this.name}>{this.label}</label> : null}
        <input
          type="checkbox"
          value={this.value}
          name={this.name}
          checked={this.selected}
          disabled={this.disabled}
          onChange={e => {
            if (this.toggleChange) {
              return this.onToggleChange(e);
            }
            this.onToggle(e);
          }}
          {...this.inputProps}
        />
      </Host>
    );
  }
}
